
import React from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import { useSuperAdminDashboard } from '@/hooks/useSuperAdminDashboard';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import BusinessSignupPlansTab from '@/components/superadmin/BusinessSignupPlansTab';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const SuperAdminBusinessSetup = () => {
  const { handleLogout } = useSuperAdminDashboard();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState('plans');

  return (
    <SuperAdminLayout
      onLogout={handleLogout}
      activeTab="business-setup"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-primary-blue">Business Setup Management</h1>
          <p className="text-gray-600">
            Manage business signup plans and configurations
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList>
            <TabsTrigger value="plans">Business Plans</TabsTrigger>
            <TabsTrigger value="orders">Plan Orders</TabsTrigger>
          </TabsList>

          <TabsContent value="plans">
            <BusinessSignupPlansTab />
          </TabsContent>

          <TabsContent value="orders">
            <Card>
              <CardHeader>
                <CardTitle>Business Plan Orders</CardTitle>
                <CardDescription>View and manage business plan orders</CardDescription>
              </CardHeader>
              <CardContent>
                <Button 
                  onClick={() => navigate('/super-admin/pending-orders')}
                  variant="outline"
                >
                  View All Orders
                </Button>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminBusinessSetup;
